import { SelectData } from './select-input.model';

export interface MovementType {
  id?: number;
  nome: string;
  tipoMovimento: string;
  codigo: string;
}

export interface MovementTypeForm {
  id?: number;
  nome: string;
  codigo: SelectData;
}


